import { createActions, createState, createReducer } from 'reduxsauce-crud'
import R from 'ramda'

const d = { deep: true }

export const MedicinesCenterRedux = createActions(
  {
    deleteMedicineRequest: ['medicine_id'],
    deleteMedicineSuccess: ['medicine_id'],
    applyMedicineRequest: ['medicine_id', 'apply_info'],
    applyMedicineSuccess: ['medicine_id', 'response'],
    applyMedicineError: ['error'],
    updateMedicines: ['data'],
    resetError: [],
  },
  {
    prefix: 'MEDICINES_CENTER_',
    defaultActions: {
      get: true,
    },
  },
)

const { Types, Creators } = MedicinesCenterRedux
export const MedicinesCenterTypes = Types
export default Creators

export const INITIAL_STATE = createState({
  sending: {
    fetching: false,
    error: null,
  },
}, {
  get: true,
})

/* ------------- Reducers ------------- */
const resetError = state => state.merge({ create: { fetching: false, error: null } }, d)

const deleteMedicineRequest = state => state.merge({ sending: { fetching: true, error: null } }, d)

const deleteMedicineSuccess = (state, { medicine_id }) => {
  const newMedicines = R.clone(state.get.results.data)
  const medicineIndex = R.findIndex(R.propEq('id', Number(medicine_id)))(newMedicines)
  newMedicines.splice(medicineIndex, 1)
  return state
    .merge({ sending: { fetching: false, error: null }, get: { results:{data: newMedicines } } }, d)
}

const applyMedicineRequest = state => state.merge({ sending: { fetching: true, error: null } }, d)

const applyMedicineSuccess = (state, { medicine_id }) => {
  const newMedicines = R.clone(state.get.results.data)
  const medicineIndex = R.findIndex(R.propEq('id', Number(medicine_id)))(newMedicines)
  newMedicines.splice(medicineIndex, 1)
  return state
    .merge({ sending: { fetching: false, error: null }, get: { results:{data: newMedicines } } }, d)
}

const applyMedicineError = (state, { error }) =>
  state.merge({ sending: { fetching: false, error } }, d)

const updateMedicines = (state, { data }) => {
  const newMedicines = R.clone(state.get.results)
 if( newMedicines.length ===0){
  window.location.reload()
}else{
      newMedicines.data.push(data)
}
  return state
    .merge({ sending: { fetching: false, error: null }, get: { results: newMedicines } }, d)
}

export const reducer = createReducer(
  INITIAL_STATE, {
    [Types.deleteMedicineRequest]: deleteMedicineRequest,
    [Types.deleteMedicineSuccess]: deleteMedicineSuccess,
    [Types.applyMedicineRequest]: applyMedicineRequest,
    [Types.applyMedicineSuccess]: applyMedicineSuccess,
    [Types.applyMedicineError]: applyMedicineError,
    [Types.updateMedicines]: updateMedicines,
    [Types.resetError]: resetError,
  },
  {
    defaultActions: {
      get: true,
    },
    Types,
  },
)



// WEBPACK FOOTER //
// ./src/Data/Redux/MedicinesCenterRedux.js